exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".portrait-block {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  text-align: center;\n  display: none;\n  background: black;\n  line-height: 1.6; }\n  .portrait-block h1 {\n    padding: 40px;\n    position: absolute;\n    width: 100%;\n    top: 40%;\n    -webkit-transform: translateY(-50%);\n            transform: translateY(-50%); }\n\n@media (orientation: portrait) {\n  .portrait-block {\n    display: block; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/portrait-block/portrait-block.component.scss
// module id = ./src/app/components/portrait-block/portrait-block.component.scss
// module chunks = main